/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { KingdomNFT, KingdomNFTInterface } from "../KingdomNFT";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "KingdomBuildingUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "KingdomCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "newUri",
        type: "string",
      },
    ],
    name: "KingdomURIChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "destroyKingdom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "enum KingdomNFT.Building",
        name: "building",
        type: "uint8",
      },
    ],
    name: "getBuildingLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getLastClaimTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "getName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "getOccupation",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getRuler",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
    ],
    name: "getTokenFromName",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
    ],
    name: "getURIFromName",
    outputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_buildingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "setBuildingLevel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "setClaimTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "occupation",
        type: "bool",
      },
    ],
    name: "setOccupation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "newUri",
        type: "string",
      },
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class KingdomNFT__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<KingdomNFT> {
    return super.deploy(_admin, overrides || {}) as Promise<KingdomNFT>;
  }
  getDeployTransaction(
    _admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_admin, overrides || {});
  }
  attach(address: string): KingdomNFT {
    return super.attach(address) as KingdomNFT;
  }
  connect(signer: Signer): KingdomNFT__factory {
    return super.connect(signer) as KingdomNFT__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): KingdomNFTInterface {
    return new utils.Interface(_abi) as KingdomNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): KingdomNFT {
    return new Contract(address, _abi, signerOrProvider) as KingdomNFT;
  }
}
